module.exports = __webpack_public_path__ + "img/description2.7b88b7c4.jpg";